import * as React from 'react';
import {useSelector} from 'react-redux';

import {ReportProviderContext} from '../../reports/report-provider-context';

import {
    getCurrentReportChartIsLoading,
    getCurrentReportChartData,
    isChartTimedOut,
    isChartErrored,
} from './pages-selectors';

type Props = {
    children: React.ReactNode;
};

export function PagesReportProvider(props: Props) {
    const chartData = useSelector((state) => getCurrentReportChartData(state));
    const isLoading = useSelector((state) => getCurrentReportChartIsLoading(state));
    const isTimedOut = useSelector((state) => isChartTimedOut(state));
    const isErrored = useSelector((state) => isChartErrored(state));

    return (
        // @ts-expect-error
        <ReportProviderContext.Provider value={{chartData, isLoading, isTimedOut, isErrored}}>
            {props.children}
        </ReportProviderContext.Provider>
    );
}
